/* MeeQ wishlist — stores product handles in localStorage, syncs hearts + badges,
   and auto-injects a wishlist heart onto every product card on the site. */
(function () {
  var KEY = 'meeq:wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

  var W = {
    list: function () { return read(); },
    has: function (h) { return read().indexOf(h) > -1; },
    count: function () { return read().length; },
    toggle: function (h) {
      if (!h) return false;
      var a = read(), i = a.indexOf(h);
      if (i > -1) { a.splice(i, 1); } else { a.push(h); }
      write(a); sync();
      document.dispatchEvent(new CustomEvent('meeq:wishlist:change', { detail: { handle: h, list: a } }));
      return a.indexOf(h) > -1;
    },
    remove: function (h) { var a = read(), i = a.indexOf(h); if (i > -1) { a.splice(i, 1); write(a); sync(); document.dispatchEvent(new CustomEvent('meeq:wishlist:change', { detail: { handle: h, list: a } })); } }
  };

  function sync() {
    var saved = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = saved.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = saved.length;
      el.style.display = saved.length > 0 ? '' : 'none';
    });
    document.querySelectorAll('.meeq-wl-product__label').forEach(function (lbl) {
      var btn = lbl.closest('[data-wishlist-toggle]');
      if (!btn) return;
      lbl.textContent = saved.indexOf(btn.getAttribute('data-handle')) > -1 ? 'Saved to wishlist' : 'Add to wishlist';
    });
  }

  /* ---- auto-inject hearts onto product cards ---- */
  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-4.5-9.5-9C1 9 2.5 5.5 6 5.5c2 0 3 1.2 6 4 3-2.8 4-4 6-4 3.5 0 5 3.5 3.5 6.5C19 16.5 12 21 12 21z"/></svg>';

  function injectHeartCSS() {
    if (document.getElementById('meeq-wl-heart-css')) return;
    var s = document.createElement('style');
    s.id = 'meeq-wl-heart-css';
    s.textContent =
      '.meeq-wl-heart{position:absolute;top:.8rem;left:.8rem;z-index:6;width:3.4rem;height:3.4rem;padding:0;border:0;border-radius:50%;' +
      'background:rgba(255,255,255,.9);box-shadow:0 .2rem .6rem rgba(0,0,0,.15);cursor:pointer;pointer-events:auto;' +
      'display:flex;align-items:center;justify-content:center;transition:transform .15s ease,background .15s ease}' +
      '.meeq-wl-heart:hover{background:#fff;transform:scale(1.08)}' +
      '.meeq-wl-heart svg{width:1.9rem;height:1.9rem;fill:none;stroke:#A11822;stroke-width:1.9}' +
      '.meeq-wl-heart.is-on svg{fill:#A11822;stroke:#A11822}' +
      '.meeq-wl-product{display:flex;align-items:center;justify-content:center;gap:.8rem;width:100%;margin-top:1rem}' +
      '.meeq-wl-product svg{width:1.8rem;height:1.8rem;fill:none;stroke:currentColor;stroke-width:1.9}' +
      '.meeq-wl-product.is-on svg{fill:#A11822;stroke:#A11822}';
    document.head.appendChild(s);
  }

  function handleFromCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function injectHearts(root) {
    injectHeartCSS();
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.meeq-wl-heart')) return;       // already has one
      var h = handleFromCard(card);
      if (!h) return;                                          // not a product card
      var host = card.querySelector('.card') || card.querySelector('.card__inner') || card;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'meeq-wl-heart';
      btn.setAttribute('data-wishlist-toggle', '');
      btn.setAttribute('data-handle', h);
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = HEART_SVG;
      host.appendChild(btn);
    });
    sync();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    W.toggle(b.getAttribute('data-handle'));
  });

  function injectProductWishlist() {
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    if (document.querySelector('.meeq-wl-product')) return;
    var target = document.querySelector('.product-form__buttons')
      || document.querySelector('product-form')
      || document.querySelector('.product-form');
    if (!target) return;
    injectHeartCSS();
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'meeq-wl-product button button--secondary';
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('data-handle', m[1]);
    btn.innerHTML = HEART_SVG + '<span class="meeq-wl-product__label">Add to wishlist</span>';
    target.insertAdjacentElement('afterend', btn);
    sync();
  }

  function boot() { injectHearts(); injectProductWishlist(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('pageshow', boot);

  // catch cards (and product buttons) added later (infinite scroll, filters, variant re-render)
  if ('MutationObserver' in window) {
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      if (pending) return;
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (
            (n.matches && (n.matches('.card-wrapper') || n.matches('.product-form__buttons') || n.matches('product-form'))) ||
            (n.querySelector && n.querySelector('.card-wrapper, .product-form__buttons, product-form'))
          )) {
            pending = true;
            (window.requestAnimationFrame || window.setTimeout)(function () { pending = false; injectHearts(); injectProductWishlist(); });
            return;
          }
        }
      }
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); });
  }

  window.MeeqWishlist = W;
})();

/* ============================================================
   MeeQ wishlist PAGE renderer
   Fills any <div id="meeq-wishlist"></div> with the saved products.
   ============================================================ */
(function () {
  var ROOT_ID = 'meeq-wishlist';

  function list() {
    if (window.MeeqWishlist && window.MeeqWishlist.list) return window.MeeqWishlist.list();
    try { return JSON.parse(localStorage.getItem('meeq:wishlist')) || []; } catch (e) { return []; }
  }
  function removeHandle(h) {
    if (window.MeeqWishlist && window.MeeqWishlist.remove) window.MeeqWishlist.remove(h);
    else {
      try {
        var a = JSON.parse(localStorage.getItem('meeq:wishlist')) || [];
        var i = a.indexOf(h); if (i > -1) { a.splice(i, 1); localStorage.setItem('meeq:wishlist', JSON.stringify(a)); }
      } catch (e) {}
    }
  }
  function cssEsc(h) { return (window.CSS && CSS.escape) ? CSS.escape(h) : String(h).replace(/"/g, '\\"'); }

  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  function money(cents) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function escAttr(s) { return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function injectCSS() {
    if (document.getElementById('meeq-wishlist-css')) return;
    var s = document.createElement('style');
    s.id = 'meeq-wishlist-css';
    s.textContent =
      '.meeq-wl__grid{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(4,1fr);gap:2.4rem}' +
      '.meeq-wl__item{position:relative;margin:0}' +
      '.meeq-wl__remove{position:absolute;top:.8rem;right:.8rem;z-index:2;width:3.2rem;height:3.2rem;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.92);box-shadow:0 .2rem .6rem rgba(0,0,0,.15);font-size:2rem;line-height:1;cursor:pointer;color:#2b2b2b;display:flex;align-items:center;justify-content:center}' +
      '.meeq-wl__remove:hover{background:#fff}' +
      '.meeq-wl__card{display:block;text-decoration:none;color:inherit}' +
      '.meeq-wl__imgwrap{position:relative;display:block;border-radius:1.6rem;overflow:hidden;background:#fff;aspect-ratio:1/1}' +
      '.meeq-wl__img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.meeq-wl__soldout{position:absolute;left:.8rem;bottom:.8rem;background:#2b2620;color:#fff;font-size:1.2rem;padding:.3rem .8rem;border-radius:.6rem}' +
      '.meeq-wl__title{display:block;margin:1rem 0 .4rem;font-size:1.5rem;line-height:1.25}' +
      '.meeq-wl__price{display:block;font-weight:700;font-size:1.5rem}' +
      '.meeq-wl__was{color:rgba(0,0,0,.45);font-weight:400;margin-right:.6rem}' +
      '.meeq-wl__empty{text-align:center;padding:4rem 0}' +
      '.meeq-wl__empty p{font-size:1.7rem;margin-bottom:1.6rem}' +
      '@media(max-width:749px){.meeq-wl__grid{grid-template-columns:repeat(2,1fr);gap:1.6rem}}';
    document.head.appendChild(s);
  }

  function cardHTML(p) {
    var sold = p.available === false ? '<span class="meeq-wl__soldout">Sold out</span>' : '';
    var was = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<s class="meeq-wl__was">' + money(p.compare_at_price) + '</s>' : '';
    return '<a class="meeq-wl__card" href="' + escAttr(p.url) + '">' +
      '<span class="meeq-wl__imgwrap"><img class="meeq-wl__img" src="' + escAttr(sized(p.featured_image, 500)) +
      '" alt="' + escAttr(p.title) + '" loading="lazy">' + sold + '</span>' +
      '<span class="meeq-wl__title">' + escAttr(p.title) + '</span>' +
      '<span class="meeq-wl__price">' + was + money(p.price) + '</span>' +
      '</a>';
  }

  function addItem(grid, h) {
    var li = document.createElement('li');
    li.className = 'meeq-wl__item';
    li.setAttribute('data-handle', h);
    li.innerHTML = '<button type="button" class="meeq-wl__remove" data-remove="' + escAttr(h) + '" aria-label="Remove from wishlist">&times;</button>';
    grid.appendChild(li);
    fetch('/products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (!p) { li.remove(); return; } li.insertAdjacentHTML('beforeend', cardHTML(p)); })
      .catch(function () { li.remove(); });
  }

  function render() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    injectCSS();
    var handles = list();
    root.innerHTML = '';
    if (!handles.length) {
      var url = root.getAttribute('data-empty-url') || '/collections/all';
      root.innerHTML = '<div class="meeq-wl__empty"><p>Your wishlist is empty. Tap the heart on any product to save it here.</p>' +
        '<a class="button" href="' + escAttr(url) + '">Browse products</a></div>';
      return;
    }
    var grid = document.createElement('ul');
    grid.className = 'meeq-wl__grid';
    root.appendChild(grid);
    handles.forEach(function (h) { addItem(grid, h); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.meeq-wl__remove[data-remove]');
    if (!btn) return;
    e.preventDefault();
    removeHandle(btn.getAttribute('data-remove'));
  });

  document.addEventListener('meeq:wishlist:change', function (e) {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    var grid = root.querySelector('.meeq-wl__grid');
    var handles = (e.detail && e.detail.list) || list();
    if (!grid) { render(); return; }
    Array.prototype.slice.call(grid.children).forEach(function (li) {
      if (handles.indexOf(li.getAttribute('data-handle')) === -1) li.remove();
    });
    handles.forEach(function (h) {
      if (!grid.querySelector('[data-handle="' + cssEsc(h) + '"]')) addItem(grid, h);
    });
    if (!grid.children.length) render();
  });

  function init() { if (document.getElementById(ROOT_ID)) render(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', init);
})();
